<template>
    <div>
        <div class="list-con">
            <el-table ref="filterTable" :data="tabelData" tooltip-effect="dark" style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column :prop="item.key" :label="item.label" v-for="item in dataSource" :key="item.key"
                    :width="item.width || ''">
                    <template slot-scope="scope">
                        <div class="text" v-if="!slotmap.includes(item.key)">
                            {{ scope.row[item.key] }}
                        </div>
                        <div class="menu-text" v-else-if="item.key == 'menu'" @click="outleft(scope.row)" :class="{default: scope.row.out_time}">
                            {{ scope.row.out_time ? '已取出' : '取出'}}
                        </div>
                        <div class="text" v-else-if="item.key == 'device'">
                            {{ scope.row.device.sn }}
                        </div>
                        <div class="text" v-else>
                            {{ formatDate(scope.row[item.key]) }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="numdata"
            style="margin-top: 30px; float: right; margin-right: 60px"
            :current-page="current_page" 
            :page-size="page_size"
            @current-change="handleCurrentChange"
            >
        </el-pagination>
        <el-dialog
            title="取出废针"
            :visible.sync="outdialog"
            width="400px"
            center
            :close-on-click-modal="false"
            >
            <div class="out-content">
                请输入取出数量
                <el-input v-model="outnum" placeholder="请输入取出数量" class="out-input"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getwaste, takewaste } from '../../api/index'
import * as XLSX from 'xlsx'

export default {
    props: {
        searchval: {
            type: String,
            default() {
                return "";
            },
        },
        searchtype: {
            type: String,
            default() {
                return "";
            },
        },
    },
    data() {
        return {
            dataSource: [
                { label: "设备编号", key: "device" },
                { label: "累计开始时间", key: "create_time" },
                { label: "累计废针数", key: "wasteNum" },
                // { label: "剩余废针数", key: "leftNum" },
                { label: "操作", key: "menu" },
                { label: "取出数量", key: "outNum" },
                { label: "取出时间", key: "out_time" },
            ],
            slotmap: ["create_time", "out_time","menu", "device"],
            tabelData: [],
            numdata: 0,
            current_page: 1,
            page_size: 8,
            outdialog: false,
            outnum: '',
            selectitem: {},
            exportLoading: false
        }
    },
    watch: {
        searchval(newValue, oldValue) {   
            if(newValue!=oldValue){
                this.current_page = 1;
                this.getData();
            }
        },
        searchtype(newValue, oldValue) {   
            if(newValue!=oldValue){
                this.current_page = 1;
                this.getData();
            }
        }     
    },
    mounted() {
        this.getData()
    },
    methods: {
		handleCurrentChange(e) {
		    this.current_page = e
            this.getData()
		},
        getData() {
            let params = {};
            if (this.searchval) {
                if (this.searchtype) {
                    params = {
                        limit: this.page_size, page: this.current_page,
                        "search[0][field]": "extra",
                        "search[0][val]": this.searchval,
                        "search[0][operator]": "LIKE",
                        "search[1][field]": "create_time",
                        "search[1][val]": this.searchtype,
                        "search[1][operator]": "RANGE",
                        "search[1][render]": "datetime",
                    };
                } else {
                    params = {
                        limit: this.page_size, page: this.current_page,
                        "search[0][field]": "extra",
                        "search[0][val]": this.searchval,
                        "search[0][operator]": "LIKE",
                    };
                }
            } else {
                if (this.searchtype) {
                    params = {
                        limit: this.page_size, page: this.current_page,
                        "search[1][field]": "create_time",
                        "search[1][val]": this.searchtype,
                        "search[1][operator]": "RANGE",
                        "search[1][render]": "datetime",
                    };
                } else {
                    params = {
                        limit: this.page_size, page: this.current_page,
                    };
                }
            }
            getwaste(params)
                .then((res) => {
                    if (res.code == 1) {
                        this.tabelData = res.data.list;
                        this.numdata = res.data.total
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        formatDate(value) {// 时间戳转换日期格式方法
            if (value == null) {
                return '';
            } else {
                value = value * 1000
                let date = new Date(value);
                let y = date.getFullYear();// 年
                let MM = date.getMonth() + 1;// 月
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();// 日
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();// 时
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();// 分
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();// 秒
                s = s < 10 ? ('0' + s) : s;
                return y + '-' + MM + '-' + d + ' ' + h + ':' + m
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        outleft(item) {
            if (item.out_time) return
            if (item.wasteNum == 0) {
                this.$message({
                    message: '暂无可取出的废针',
                    type: 'warning'
                })
                return
            }
            this.selectitem = item
            this.outdialog = true
        },
        confirm() {
            if (!this.outnum || +this.outnum < 1 || isNaN(Number(this.outnum))) {
                this.$message({
                    message: '请输入正确的数量',
                    type: 'warning'
                })
                return
            }
            const vdata = {
                id: this.selectitem.id,
                outNum: +this.outnum
            }
            takewaste(vdata).then(res => {
                if (res.code == 1) {
                    this.outdialog = false
                    this.current_page = 1
                    this.getData()
                }
            })
        },
        async exportExcel() {
            this.exportLoading = true
            try {
                const res = await new Promise((resolve, reject) => {
                    this.fetchAllData(resolve, reject, 1, [])
                })
                const exportData = res.map(item => ({
                    '设备编号': item.device ? item.device.sn : '',
                    '累计开始时间': this.formatDate(item.create_time),
                    '累计废针数': item.wasteNum,
                    '取出数量': item.outNum || '',
                    '取出时间': this.formatDate(item.out_time)
                }))
                const ws = XLSX.utils.json_to_sheet(exportData)
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, '废针管理')
                XLSX.writeFile(wb, '废针管理数据.xlsx')
            } catch (error) {
                console.log(error)
                this.$message.error('导出失败')
            }
            this.exportLoading = false
        },
        fetchAllData(resolve, reject, page, allData) {
            let params = {}
            if (this.searchval) {
                params = {
                    limit: 100, page: page,
                    "search[0][field]": "extra",
                    "search[0][val]": this.searchval,
                    "search[0][operator]": "LIKE",
                }
            } else {
                params = {
                    limit: 100, page: page,
                }
            }
            getwaste(params)
                .then((res) => {
                    if (res.code == 1) {
                        const newData = allData.concat(res.data.list)
                        if (res.data.list.length < 100) {
                            resolve(newData)
                        } else {
                            this.fetchAllData(resolve, reject, page + 1, newData)
                        }
                    } else {
                        reject(new Error(res.msg))
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        },
    }
}
</script>

<style lang="scss" scoped>
.tab-menu {
    display: flex;
    align-items: center;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 14px;
    color: #507af9;
    column-gap: 13px;

    .line {
        width: 1px;
        height: 12px;
        background: #e6e6e6;
    }

    .edit {
        cursor: pointer;
    }

    .delbtn {
        cursor: pointer;
        color: #f95050;
    }
}

.content {
    color: #f95050;
}
</style>